import { NON_STANDARD_HIGH_SCHOOL_CURRICULUM_KEYS } from '@mathflat/domain/Curriculum'
import { makeObservable } from 'mobx'
import { SchoolGradeSemesterSubjectFilter } from 'src/dto'
import type { SchoolGradeSemesterSubjectParamT } from 'src/dto/common/SchoolGradeSemesterSubjectFilter'

import commonRepo from '@/repository/common.repo'
import { curriculumCoreService } from '@/service/curriculumCore.service'

export class FavoriteProblemFilter<
  ParamT extends SchoolGradeSemesterSubjectParamT,
> extends SchoolGradeSemesterSubjectFilter<ParamT> {
  constructor() {
    const params = commonRepo.isSolo
      ? { schoolType: commonRepo.permission.bySubscription.firstSubscriptedSchoolType }
      : { schoolType: 'ALL' }

    super({
      elementaryDropdownList: [],
      middleDropdownList: [],
      highDropdownList: [],
      params: params as ParamT,
    })

    if (commonRepo.isSolo) {
      this.selectedTrieKey = commonRepo.permission.bySubscription.firstSubscriptionTrieKeys[0]
    }

    this.elementaryDropdownList = curriculumCoreService.getGradeSemesterElementary({
      includePreOpen: false,
    })
    this.middleDropdownList = curriculumCoreService.getGradeSemesterMiddle({
      includePreOpen: false,
    })

    this.highDropdownList = [
      ...curriculumCoreService.getGradeSubjectHigh({
        includePreOpen: false,
      }),
      ...curriculumCoreService.getNonStandardGradeSubjectHigh({
        trieKeys: [NON_STANDARD_HIGH_SCHOOL_CURRICULUM_KEYS.CURRICULUM_KEY_고등학교_구_교육과정],
      }),
    ]

    makeObservable(this)
  }
}
